import { jsx as _jsx } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { Base } from '@stepstone-genesis/components';
import { formNavigationMiddleware } from './formNavigationMiddleware.js';
import { addDynamicGlobalTrackingLibraryScript } from '../../../tracking/tools.js';
import { useAppDispatch, useAppSelector } from '../../hooks.js';
import { activeViewSelector, setActiveView, setActiveWrapper, } from '../../core/wrapperContext/wrapperContextSlice.js';
import { inlineFormsConfigs } from './inlineFormsConfigs.js';
export const InlineForm = ({ formType, encodedGTLibraryUrl, }) => {
    const dispatch = useAppDispatch();
    formNavigationMiddleware.add();
    useEffect(() => {
        addDynamicGlobalTrackingLibraryScript(encodedGTLibraryUrl);
        dispatch(setActiveWrapper('inlineForm'));
    });
    const activeViewFromSelector = useAppSelector(activeViewSelector);
    if (!activeViewFromSelector) {
        dispatch(setActiveView(formType));
    }
    const activeView = activeViewFromSelector ? activeViewFromSelector : formType;
    const forms = inlineFormsConfigs();
    const activeFormConfig = forms.find(({ type }) => type === activeView);
    const ViewComponent = activeFormConfig?.component;
    if (!activeView) {
        console.log(`Unable to find component for specific form type: ${activeView}`);
        return null;
    }
    return ViewComponent ? (_jsx(Base, { "data-testid": `${formType}-form-container`, children: _jsx(ViewComponent, {}) })) : null;
};
//# sourceMappingURL=InlineForm.js.map